import styled from "@emotion/styled";

export const StyledCreateTaskModal = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;

  .comment-title {
    margin: 0px;
  }

  .left-div {
    width: 60%;
    .task-title {
      display: inline-flex;
      align-items: center;
      margin-bottom: 12px;
      color: #262626;
      font-size: 18px;
      font-weight: 600;
      line-height: 1;
    }
  }
  .right-div {
    width: 40%;
  }
  .left-div {
    max-height: calc(100dvh - 70px) !important;
    overflow-y: scroll;
  }

  @media (max-width: 768px) {
    flex-direction: column;

    .left-div,
    .right-div {
      width: 100%;
    }
  }
`;
